import { render } from "./About.vue?vue&type=template&id=c323ee04&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=c323ee04&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c323ee04"

export default script